import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { handleOnInitQueryStarted } from "appRedux/helpers/initApiHelpers"

export const initApi = createApi({
  reducerPath: "initApi",
  baseQuery: baseQueryWithMiddlewares("/init"),
  endpoints: (builder) => ({
    init: builder.query<InitResponseDto, void>({
      query: () => "",
      onQueryStarted: handleOnInitQueryStarted
    })
  })
})

export const {
  useInitQuery,
  useLazyInitQuery
} = initApi
